export default __webpack_public_path__ + "static/media/login.56eb3551.png";